import { useLocale } from "../i18n";
import { cn } from "./ui";

/**
 * Vendor mark. The workspace carries the agency's own brand (logo, colors, name); this is the one place 10x appears,
 * so a prospect sees "their" system powered by us. Text only: no 10x artwork exists in the repo yet.
 */
export function PoweredBy({ className, tone = "muted" }: { className?: string; tone?: "muted" | "onDark" }) {
  const { locale } = useLocale();
  return <PoweredByStatic locale={locale} className={className} tone={tone} />;
}

/** Same mark for pages rendered outside the authenticated ConfigProvider (sign-in, intake), which carry their own locale. */
export function PoweredByStatic({ locale, className, tone = "muted" }: { locale: "en" | "es"; className?: string; tone?: "muted" | "onDark" }) {
  return (
    <p className={cn("text-[11px] leading-tight whitespace-nowrap", tone === "onDark" ? "text-white/70" : "text-ink/50", className)}>
      {locale === "es" ? "Con tecnología de" : "Powered by"} <span className={cn("font-extrabold tracking-tight", tone === "onDark" ? "text-white" : "text-ink/80")}>10x</span>
    </p>
  );
}
